import _ from 'lodash';
import { restClient } from 'libs/restClient';
import { notifyMessages } from 'helpers/NotifyHelper';
import * as actions from 'actions/types';

export function uploadSupportDocument({
  fileContent,
  title,
  slot,
  requestId,
  sendEmail = true
}) {
  // create new form-data object to send file
  const bodyFormData = new FormData();
  bodyFormData.append('file', fileContent);

  // send request to backend and upload file
  const url = `/requests/${requestId}/documents/${slot}?title=${title}&sendEmail=${sendEmail}`;

  // make request
  const payload = restClient
    .post(url, bodyFormData)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.UPLOAD_SUPPORT_DOC,
    payload
  };
}

export function uploadUsersManual({ fileContent, title, slot, modelId }) {
  // create new form-data object to send file
  const bodyFormData = new FormData();
  bodyFormData.append('file', fileContent);

  // send request to backend and upload file
  const url = `/devicemodels/${modelId}/manual?title=manual`;

  // make request
  const payload = restClient
    .post(url, bodyFormData)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.UPLOAD_USERS_MANUAL,
    payload
  };
}

export function addToQueue({ slot, title }) {
  const slotTitle = _.trim(title);
  return {
    type: actions.ADD_TO_QUEUE,
    payload: {
      [slot]: { title: slotTitle, pending: true }
    }
  };
}

export function removeFromQueue({ slot, ...rest }) {
  return {
    type: actions.REMOVE_FROM_QUEUE,
    payload: {
      [slot]: { pending: false, ...rest }
    }
  };
}

export function clearQueue() {
  return {
    type: actions.CLEAR_QUEUE,
    payload: null
  };
}

export function deleteUsersManual(modelId) {
  const payload = restClient
    .delete(`/devicemodels/${modelId}/manual`)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.DELETE_USERS_MANUAL,
    payload
  };
}

export function deleteSupportDocument(requestId, slot) {
  const payload = restClient
    .delete(`/requests/${requestId}/documents/${slot}`)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.DELETE_SUPPORT_DOCUMENT,
    payload
  };
}

export function uploadTestReport({ fileContent, title, slot, testId }) {
  const bodyFormData = new FormData();
  bodyFormData.append('file', fileContent);
  bodyFormData.append('title', title);

  const url = `/requesttests/${testId}/reports/${slot}`;

  const payload = restClient
    .post(url, bodyFormData)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.UPLOAD_TEST_REPORT,
    payload
  };
}

export function deleteTestReport(testId, slot) {
  const payload = restClient
    .delete(`/requesttests/${testId}/reports/${slot}`)
    .then(response => {
      Promise.resolve(true);
      return response;
    })
    .catch(err => {
      Promise.reject(notifyMessages.cantDeleteUploadedFile);
      return err;
    });

  return {
    type: actions.DELETE_TEST_REPORT,
    payload
  };
}

export function updateReportTitle(testId, slot, title) {
  const newTitle = _.trim(title);
  const body = { args: { title: newTitle } };
  const payload = restClient
    .put(`/requesttests/${testId}/reports/${slot}`, JSON.stringify(body))
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.UPDATE_DOCUMENT_TITLE,
    payload
  };
}

export function updateSupDocTitle(requestId, slot, title) {
  const newTitle = _.trim(title);
  const body = { args: { title: newTitle } };
  const payload = restClient
    .put(`/requests/${requestId}/documents/${slot}`, JSON.stringify(body))
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.UPDATE_DOCUMENT_TITLE,
    payload
  };
}



// WEBPACK FOOTER //
// ./src/actions/uploads.js